/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import ArticleList from './ArticleList'
import useCategoriesOptions from '../../../hooks/useCategoriesOptions'
import ArticleFilter from './ArticleFilter'
import {IArticleList} from '../core/_model'
import DeleteArticle from '../Modal/DeleteArticle'
import {Link} from 'react-router-dom'

const Article = () => {
  const {categoriesOptions} = useCategoriesOptions()

  const [searchTerm, setSearchTerm] = useState('')
  const [selectedArticle, setSelectedArticle] = useState<IArticleList | null>(null)
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null)

  const onSelectArticle = (article: IArticleList) => setSelectedArticle(article)

  const onSelectCategoryId = (id: number) => setSelectedCategoryId(id)

  const onDeselectArticle = () => setSelectedArticle(null)

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <div className='d-flex align-items-center position-relative my-1 w-500px'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-700'
            placeholder='Search by category name'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className='d-flex gap-2'>
          <ArticleFilter
            categoriesOptions={categoriesOptions}
            selectedCategoryId={selectedCategoryId}
            onSelectCategoryId={onSelectCategoryId}
          />

          <Link to='/knowledgebase/article/create' className='btn btn-primary'>
            <KTIcon iconName='plus' className='fs-2' />
            Add New Article
          </Link>
        </div>
      </div>

      <ArticleList
        searchTerm={searchTerm}
        selectedArticle={onSelectArticle}
        selectedCategoryId={selectedCategoryId}
      />

      <DeleteArticle
        selectedDeleteArticle={selectedArticle}
        onDeselectArticle={onDeselectArticle}
      />
    </>
  )
}

export default Article
